import type { SVGProps } from 'react';

const SvgCommentHidden = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10.13 5.22C10.73 5.08 11.36 5 12 5c3.86 0 7 2.69 7 6 0 .79-.18 1.56-.53 2.29-.24.5-.03 1.09.46 1.34.14.07.29.1.43.1.37 0 .73-.21.9-.56.48-1 .73-2.06.73-3.16 0-4.41-4.04-8-9-8-.79 0-1.57.09-2.33.27-.54.13-.87.67-.74 1.2s.66.87 1.2.74zM4.71 3.29A.996.996 0 1 0 3.3 4.7l1.5 1.5C3.64 7.58 3 9.24 3 10.99s.71 3.6 2 5.02v3.98a1 1 0 0 0 1.44.9l4.08-2c2.07.3 4.19-.05 5.98-.97l2.78 2.78c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zm5.84 13.58c-.21-.04-.43 0-.62.09L7 18.4v-2.78c0-.27-.11-.52-.29-.71C5.61 13.82 5 12.43 5 11c0-1.21.43-2.38 1.22-3.37L15 16.41c-1.37.56-2.94.73-4.45.46"
    />
  </svg>
);
export default SvgCommentHidden;
